// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UUlFWG0kB9qZkF {
  height: 100%;
}
.zk8zHGIrdWTzRH {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-050, 4px) var(--ds-space-150, 10px) 36px var(--ds-space-150, 10px);
  transition: padding 0.2s ease-in-out;
  background: var(--ds-surface, #ffffff);
}
.zk8zHGIrdWTzRH .MnV6YwFPUMdiez,
.zk8zHGIrdWTzRH .olYWirxR10KX0Z {
  position: relative;
  height: 100%;
}
.zk8zHGIrdWTzRH .olYWirxR10KX0Z {
  border-radius: var(--ds-border-radius-400, 16px);
}
.zk8zHGIrdWTzRH.k1VC6Qkrse8JvP {
  bottom: var(--ds-space-800, 64px);
}
.zk8zHGIrdWTzRH.s4yvt0dds3eZMC {
  padding: var(--ds-space-0, 0);
}
.zk8zHGIrdWTzRH.s4yvt0dds3eZMC .olYWirxR10KX0Z {
  border-radius: unset;
}
@media print {
  .zk8zHGIrdWTzRH {
    flex-direction: column;
  }
}
`, ""]);
// Exports
export var manager = `UUlFWG0kB9qZkF`;
export var splitscreen = `zk8zHGIrdWTzRH`;
export var content = `MnV6YwFPUMdiez`;
export var inboxContent = `olYWirxR10KX0Z`;
export var tabs = `k1VC6Qkrse8JvP`;
export var single = `s4yvt0dds3eZMC`;
export default ___CSS_LOADER_EXPORT___;
